module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ch6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("“‘Then something began to hurt Mowgli inside him”—Michael reads out loud—“as he had never been hurt before and he caught his breath and sobbed and the tears ran down his face.’”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It’s not Shakespeare. It’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Jungle Book")]), _vm._v(" by Rudyard Kipling. It’s Jamie’s favorite and though Michael constantly suggests other books—"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Tom Sawyer, Twenty Thousand Leagues, Lemony Snicket")]), _vm._v("—Jamie insists it be read every night.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“‘What is it? What is it?” he said. “I do not wish to leave the jungle and I do not know what this is? Am I dying, Baghera?’”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“‘No, Little Brother. Those are only tears such as men use.’”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Lately Michael wonders if Jamie isn’t too old to be read to, too old for Michael to be curled up next to him on the narrow bed.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“‘So Mowgli sat and cried as though his heart would break and he had never cried in all his life before.’”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jamie hasn’t cried since he was a baby. The falls and bruises that would bring any other child to tears have always left him seemingly puzzled, as if they were something unfathomable that needed to be figured out.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“‘Now,” he said, “I will go to men. But first I must say farewell to my mother.’”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Both of them know that as Mowgli says good-bye, he will cry on her coat. “I loved thee more than ever I loved my cubs,” she will say.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“‘The dawn was beginning to break when Mowgli went down the hillside alone, to meet those mysterious things called men.’” Michael closes the book. “Bedtime, bub.” He quickly rises.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Where’s my mom?” Jamie is looking straight ahead.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Michael is aware of the sudden tension in his stomach. A tug. A flutter.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You know the answer to that, Jamie.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“She’s working.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“She’s traveling.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“She’s out in the world of men,” says Jamie, “and she is busy but she loves me.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Thank you, Mr. Kipling.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You got it.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I want to sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He quickly rolls away. Michael turns off the light. He bends to kiss Jamie.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“’Night, little man.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jamie doesn’t answer. The light in the bathroom is on and Michael moves around the bed and goes in to turn it off. There are clippings taped on the tile above the counter. Michael doesn’t have to look at them to know they’re there. One is an old cover from "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Surfing")]), _vm._v(" magazine. A younger Michael cuts across the face of a wave. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Michael Hodge at Pipeline.")]), _vm._v(" On it, Jamie has scrawled a word in clumsy Magic Marker.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("DAD.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Next to the cover is an old print ad from a magazine. The woman in the photo, a blond young mother holding a baby, is beautiful, confident, and serene in the way that mothers can only be in the minds of advertisers.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("MOM.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Out in the world of men.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-578040e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter6.vue
// module id = 93
// module chunks = 0